module.exports = __webpack_public_path__ + "static/startup-the-bank-f92d91158b882f4515f22b42232196db.svg";